import type { CSSProperties } from "react";

export const fullPageCentred: CSSProperties = {
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
};
